interface Theme {
  id: number;
  text: string;
  name: string;
}

const themes: Theme[] = [
  { id: 1, text: 'Light', name: 'light-theme' },
  { id: 2, text: 'ViewNexa Light', name: 'light-theme-viewnexa' },
  { id: 3, text: 'Dark', name: 'dark-theme' },
  { id: 4, text: 'ViewNexa Dark', name: 'dark-theme-viewnexa' },
];

// Legacy themes are remapped to their ViewNexa equivalents on load.
const themeMapping: Record<string, string> = {
  'light-theme': 'light-theme-viewnexa',
  'dark-theme': 'dark-theme-viewnexa',
};

const DEFAULT_THEME_NAME = 'light-theme-viewnexa';

// Resolves a stored/legacy theme name to the active theme name we render with.
const resolveThemeName = (name: string | null | undefined): string => {
  if (name && themeMapping[name]) {
    return themeMapping[name];
  }
  if (name && themes.some((t) => t.name === name)) {
    return name;
  }
  return DEFAULT_THEME_NAME;
};

// Applies the non-React side effects of a theme: body class (legacy SCSS scope),
// the theme's stylesheet, and persistence. The React state lives in
// ThemeModeProvider, which is the source of truth and calls this on change.
const applyTheme = (name: string): void => {
  const themeName = resolveThemeName(name);

  const body = document.getElementsByTagName('body')[0];
  if (body) {
    body.removeAttribute('class');
    body.classList.add(themeName);
  }

  require(`../src/assets/themes/${themeName}/index.scss`);
  localStorage.setItem('app-theme', themeName);
};

export type { Theme };
export { applyTheme, DEFAULT_THEME_NAME, resolveThemeName, themeMapping, themes };
